export interface APIErrorResponse {
  code: string;
  message: string;
  httpStatus?: number;
}

/** @hidden */
export function isAPIErrorResponse(object: any): object is APIErrorResponse {
  return (
    (<APIErrorResponse>object).code !== undefined &&
    (<APIErrorResponse>object).message !== undefined
  );
}
